import { PublicConfigurationT } from "@swo/shared";

export function contentFulEntryLink(entryId: string, config: PublicConfigurationT) {
  return `https://app.contentful.com/spaces/${config.contentful.space}/environments/${config.contentful.environment}/entries/${entryId}`;
}
